<template>
    <div class="login-vue">
        <div class="container">
            <p class="title">登&nbsp;录</p>
            <div class="input-c">
                <Input prefix="ios-contact" v-model="account" placeholder="手机号" clearable />
                <p class="error">{{accountError}}</p>
            </div>
            <div class="input-c">
                <Input type="password" v-model="pwd" prefix="md-lock" placeholder="密码" clearable
                @keyup.enter.native="submit" />
                <p class="error">{{pwdError}}</p>
            </div>
            <Button :loading="isShowLoading" class="submit" type="primary" @click="submit">登 录</Button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    data() {
        return {
            account: '',
            pwd: '',
            accountError: '',
            pwdError: '',
            isShowLoading: false,
        }
    },
    watch: {
        $route: {
            handler(route) {
                this.redirect = route.query && route.query.redirect
            },
            immediate: true,
        },
    },
    methods: {
        register() {
            this.$router.push('/register')
        },
        forgetPwd() {
            this.$router.push('/forget-password')
        },
        submit() {
            const that = this;
            if (!that.account) {
                return that.accountError = '请输入手机号'
            }
            if (!that.pwd) {
                return that.pwdError = '请输入密码'
            }
            that.$axios({
                url:'/api/user/login',
                method:'post',
                data:{
                    account:that.account,
                    password:that.pwd
                }
            }).then(res => {
                that.isShowLoading = true
                const {userinfo} = res.data
                // // 登陆成功 设置用户信息
                localStorage.setItem('userImg', userinfo.avatar)
                localStorage.setItem('userName', userinfo.nickname)
                // // 登陆成功 假设这里是后台返回的 token
                localStorage.setItem('token', userinfo.token)
                that.$router.push({ path: that.redirect || '/home' })
            })
        },
    },
}
</script>

<style>
.login-vue {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: url('../assets/imgs/bg_img@2x.png') no-repeat center / cover;

}
.login-vue .container {
    background: linear-gradient(180deg, rgba(24, 106, 197, 0.7) 0%, rgba(24, 106, 197, 0.2) 100%);
    width: 500px;
    text-align: center;
    border-radius: 10px;
    padding: 30px;
}
.login-vue .ivu-input {
    background-color: transparent;
    color: #fff;
    outline: #fff;
    border-color: #fff;
}
.login-vue ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: rgba(255, 255, 255, .8);
}
.login-vue :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(255, 255, 255, .8);
}
.login-vue ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(255, 255, 255, .8);
}
.login-vue :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(255, 255, 255, .8);
}
.login-vue .title {
    font-size: 36px;
    margin-bottom: 20px;
}
.login-vue .input-c {
    margin: auto;
    width: 200px;
}
.login-vue .error {
    color: red;
    text-align: left;
    margin: 5px auto;
    font-size: 12px;
    height: 20px;
}
.login-vue .submit {
    width: 200px;
}
.login-vue .account {
    margin-top: 30px;
}
.login-vue .account span {
    cursor: pointer;
}
.login-vue .ivu-icon {
    color: #eee;
}
.login-vue .ivu-icon-ios-close-circle {
    color: #777;
}
</style>
